"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4866],{

/***/ 27163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ UtilityPagesApi; }
/* harmony export */ });
/* harmony import */ var _parkschannel_next_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74552);

class UtilityPagesApi {
    getUtilityPage(slug) {
        return this.client.get("/api/utils-pages/slugs/".concat(slug), {}, false);
    }
    constructor(client = new _parkschannel_next_utils__WEBPACK_IMPORTED_MODULE_0__/* .HttpClient */ .e()){
        this.client = client;
    }
}


/***/ }),

/***/ 921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ OurPartnersSection; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Carousel/Carousel.tsx
var Carousel = __webpack_require__(7346);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./modules/ImgixImage/index.tsx
var ImgixImage = __webpack_require__(86645);
;// CONCATENATED MODULE: ./modules/Partners/OurPartnersSection/OurPartnersCarousel.tsx





const responsive = {
    0: {
        items: 2
    },
    568: {
        items: 3
    },
    768: {
        items: 4
    },
    1280: {
        items: 6
    },
    1536: {
        items: 7
    },
    1800: {
        items: 8
    },
    1920: {
        items: 10
    }
};
const OurPartnersCarousel = (param)=>{
    let { carouselRef , itemBackground , data  } = param;
    const slides = (0,react.useMemo)(()=>data.map((slide)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(OurPartnersCarouselItem, {
                data: slide,
                itemBackground: itemBackground
            }, slide.id)), [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        disableDotsControls: true,
        responsive: responsive,
        paddingRight: 50,
        ref: carouselRef,
        items: slides
    });
};
function OurPartnersCarouselItem(param) {
    let { data , itemBackground ="white"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("w-[120px] h-[120px] bg-white rounded-full flex items-center p-4 justify-center overflow-hidden lg:p-6 lg:w-[200px] lg:h-[200px] ", renderItemBackground(itemBackground)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: data.link,
            target: "_blank",
            className: "w-full h-full relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgixImage/* ImgixImage */.T, {
                src: data.avatar_key || "",
                fill: true,
                className: "object-contain",
                alt: "".concat(data.name, " logo")
            })
        })
    });
}
function renderItemBackground(bgc) {
    switch(bgc){
        case "gray":
            return "bg-neutral-50";
        default:
            return "bg-white";
    }
}

// EXTERNAL MODULE: ../ui/src/components/Wrappers/InsidePageWrapper.tsx
var InsidePageWrapper = __webpack_require__(70996);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ../ui/src/components/IconButton/IconButton.tsx
var IconButton = __webpack_require__(38937);
// EXTERNAL MODULE: ../ui/src/icons/ChevronLeft/ChevronLeft.tsx
var ChevronLeft = __webpack_require__(7595);
// EXTERNAL MODULE: ../ui/src/icons/ChevronRight/ChevronRight.tsx
var ChevronRight = __webpack_require__(98427);
// EXTERNAL MODULE: ./modules/Api/UtilitiesPages/index.ts
var UtilitiesPages = __webpack_require__(27163);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.2.1_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(15265);
;// CONCATENATED MODULE: ./modules/Partners/hooks.ts


const useOurPartners = ()=>{
    const utilityPages = new UtilitiesPages/* UtilityPagesApi */.d();
    const useOurPartnersQuery = function() {
        let slug = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "our-partners";
        return (0,index_production.useQuery)([
            "utility-pages",
            slug
        ], ()=>utilityPages.getUtilityPage(slug), {
            refetchOnWindowFocus: false,
            retry: false
        });
    };
    return {
        useOurPartnersQuery
    };
};

;// CONCATENATED MODULE: ./modules/Partners/types.ts
class OurPartner {
    static fromOurPartnersResponse(data) {
        var ref;
        return new OurPartner((ref = data.avatarKey) === null || ref === void 0 ? void 0 : ref.key, data.id, data.name, data.link);
    }
    toJSON() {
        return {
            avatar_key: this.avatar_key,
            id: this.id,
            name: this.name,
            link: this.link,
            avatar_url: this.avatar_key
        };
    }
    get avatar_url() {
        if (!this.avatar_key) return this.avatar_key;
        return "/api/utils-pages/images?imageKey=".concat(this.avatar_key);
    }
    constructor(avatar_key, id, name, link){
        this.avatar_key = avatar_key;
        this.id = id;
        this.name = name;
        this.link = link;
    }
}

;// CONCATENATED MODULE: ./modules/Partners/OurPartnersSection/OurPartnersSection.tsx






const OurPartnersSection = (param)=>{
    let { itemBackground  } = param;
    const carouselRef = (0,react.useRef)(null);
    const { useOurPartnersQuery  } = useOurPartners();
    const { data: ourPartners  } = useOurPartnersQuery();
    const partners = (0,react.useMemo)(()=>{
        var ref;
        return ((ourPartners === null || ourPartners === void 0 ? void 0 : (ref = ourPartners.data) === null || ref === void 0 ? void 0 : ref.partners) || []).map((member)=>OurPartner.fromOurPartnersResponse(member));
    }, [
        ourPartners
    ]);
    const slideNext = ()=>{
        if (!carouselRef.current) return;
        carouselRef.current.slideNext(null);
    };
    const slidePrev = ()=>{
        if (!carouselRef.current) return;
        carouselRef.current.slidePrev(null);
    };
    if (partners.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "w-full overflow-x-hidden pt-6 pb-[72px] lg:pt-[56px] lg:pb-[100px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4 md:px-[30px] lg:px-[40px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsidePageWrapper/* InsidePageWrapper */.n, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center mb-6 lg:mb-[60px] ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                component: "h2",
                                variant: "h3",
                                className: "text-neutral-900",
                                children: "Our partners"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hidden lg:flex lg:gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                                        size: "sm",
                                        variant: "base",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* ChevronLeft */.s, {}),
                                        onClick: slidePrev
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                                        size: "sm",
                                        variant: "base",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* ChevronRight */._, {}),
                                        onClick: slideNext
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OurPartnersCarousel, {
                carouselRef: carouselRef,
                itemBackground: itemBackground,
                data: partners
            })
        ]
    });
};


/***/ }),

/***/ 14866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OurPartnersSection": function() { return /* reexport */ OurPartnersSection/* OurPartnersSection */.o; }
});

// EXTERNAL MODULE: ./modules/Partners/OurPartnersSection/OurPartnersSection.tsx + 3 modules
var OurPartnersSection = __webpack_require__(921);
;// CONCATENATED MODULE: ./modules/Partners/OurPartnersSection/index.ts


;// CONCATENATED MODULE: ./modules/Partners/index.ts



/***/ }),

/***/ 7595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ChevronLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ChevronLeft = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5182 11.9998L15.6582 17.2468C16.0743 17.6108 16.1163 18.2428 15.7522 18.6578C15.3882 19.0738 14.7563 19.1158 14.3413 18.7528L8.34125 12.7518C7.88625 12.3538 7.88625 11.6458 8.34125 11.2478L14.3413 5.24782C14.7563 4.88382 15.3882 4.92582 15.7522 5.34082C16.1163 5.75682 16.0743 6.38882 15.6582 6.75182L10.5182 11.9998Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "paint0_linear_712_11636",
                    x1: "8",
                    y1: "6.68962",
                    x2: "16.8537",
                    y2: "7.59025",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            stopColor: "#2CBC32"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.98762",
                            stopColor: "#07996E"
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 98427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ChevronRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ChevronRight = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9 5L16 12L9 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ })

}]);